<script lang="ts" generic="T" setup>
import { computed, PropType } from 'vue'

import AppButtonIcon from '../atoms/AppButtonIcon.vue'

const props = defineProps({
  list: { type: Array as PropType<T[]>, required: true }
})

const currentIndex = defineModel<number>('currentIndex')

const current = computed<T>(() => (props.list[currentIndex.value]))
const nextDisabled = computed<boolean>(() => currentIndex.value === props.list.length - 1)
const prevDisabled = computed<boolean>(() => currentIndex.value <= 0)

const next = () => { !nextDisabled.value && currentIndex.value++ }
const prev = () => { !prevDisabled.value && currentIndex.value-- }
</script>

<template>
  <nav class="relative">
    <div
      v-if="$slots?.['top-label']"
      class="absolute bottom-full left-0 right-0 flex items-center justify-center pb-4"
    >
      <slot v-bind="{ item: current }" name="top-label" />
    </div>
    <div
      v-if="$breakpoints.ltLg"
      class="flex items-center justify-between py-6 border-t border-black"
    >
      <AppButtonIcon
        :disabled="prevDisabled"
        icon="arrow-circle"
        size="md"
        @click="prev"
      />
      <Transition mode="out-in">
        <div v-if="current" :key="currentIndex" class="shrink-0">
          <slot v-bind="{ item: current, itemIndex: currentIndex, currentIndex }" />
        </div>
      </Transition>
      <AppButtonIcon
        :disabled="nextDisabled"
        icon="arrow-circle"
        size="md"
        class="transform scale--100"
        @click="next"
      />
    </div>
    <ul
      v-else
      :class="{ 'border-t border-black': $slots?.['top-label'] }"
      class="flex items-center justify-between py-6"
      tabindex="-1"
    >
      <li
        v-for="(item, itemIndex) in list"
        :key="`item-${itemIndex}`"
        class="flex-1 flex items-center justify-center"
      >
        <slot v-bind="{ item, itemIndex, currentIndex }" />
      </li>
    </ul>
  </nav>
</template>
